<template>
  <div class="weather-forecast">
    <v-layout row wrap>
      <br />
      <v-flex md12 sm12 lg12 xs12>
        <v-card class="forecast-box">
          <v-toolbar
            dark
            style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; cursor: pointer;"
            @click="forecastReadyDaily = !forecastReadyDaily"
          >
            <v-toolbar-title
              center
              style="color: white !important; text-align: center !important;"
              class="justify-center"
            >
              <h4 class="text-xs-center">
                <v-icon class="icon">mdi-calendar-today</v-icon>TODAY'S FORECAST
              </h4>
            </v-toolbar-title>
          </v-toolbar>

          <template v-if="forecastReadyDaily">
            <div class="scrolling-wrapper" id="content">
              <v-btn
                @click="swipeLeft"
                @mouseover="swipeLeft"
                color="grey lighten-1"
                fab
                small
                absolute
                left
                class="nav"
              >
                <v-icon class="icon">mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                @click="swipeRight"
                @mouseover="swipeRight"
                color="grey lighten-1"
                fab
                small
                absolute
                right
                class="nav"
              >
                <v-icon class="icon">mdi-chevron-right</v-icon>
              </v-btn>

              <div v-for="(hourly, i) in forecastHora" :key="i" class="card">
                <p align="start" class="daily">
                  <br />
                  <strong>{{ hourly.dt }}</strong>
                </p>
                <h6 align="start" class>
                  <strong>{{ hourly.weather }}</strong>
                </h6>
                <img
                  :src="hourly.icon"
                  align="center"
                  class="weatherIcon-daily"
                />
                <p align="start" class="daily">
                  <br />Clouds:
                  <strong>{{ hourly.clouds }}%</strong>
                </p>
                <p align="start" class="daily">
                  <br />Temp:
                  <strong>{{ hourly.temp }} F</strong>
                </p>
                <p align="start" class="daily">
                  <br />Humidity:
                  <strong>{{ hourly.humidity }}%</strong>
                </p>
                <p align="start" class="daily">
                  <br />Wind Speed:
                  <strong>{{ hourly.wind_speed }} m/h</strong>
                </p>
                <div class="vl"></div>
              </div>
            </div>
          </template>
        </v-card>
      </v-flex>

      <v-flex md12 sm12 lg12 xs12>
        <v-card class="forecast-box">
          <v-toolbar
            dark
            style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; cursor: pointer;"
            @click="forecastReadyWeekly = !forecastReadyWeekly"
          >
            <v-toolbar-title
              center
              style="color: white !important; text-align: center !important;"
              class="justify-center"
            >
              <h4 class="text-xs-center">
                <v-icon class="icon">mdi-calendar-range</v-icon>WEEKLY FORECAST
              </h4>
            </v-toolbar-title>
          </v-toolbar>

          <template v-if="forecastReadyWeekly">
            <v-layout row wrap class="box">
              <div
                v-for="(weather, i) in weatherArray"
                :key="i"
                class="forecastBox"
              >
                <v-flex class="day">
                  <h6 :class="i == 0 ? 'today' : ''">
                    <strong>{{ date[i].toLocaleString() }}</strong>
                  </h6>
                  <h6 :class="i == 0 ? 'today' : ''">{{ weatherArray[i] }}</h6>
                  <img
                    :src="weatherIconArray[i]"
                    align="center"
                    class="weatherIcon"
                  />
                  <p align="start">
                    <br />Precipitation:
                    <strong :class="rain[i] > 10 ? 'rainy' : ''"
                      >{{
                        rain[i] != undefined ? (rain[i] / 25.4).toFixed(2) : 0
                      }}in</strong
                    >
                    <br />Humidity:
                    <strong>{{ humidityArray[i] }}%</strong>
                    <br />Max Temp:
                    <strong>{{ tmax[i] }} F</strong>
                    <br />Min Temp:
                    <strong>{{ tmin[i] }} F</strong>
                    <br />Max Wind Speed:
                    <strong :class="windSpeed[i] < 4 ? '' : 'alert'">
                      {{ windSpeed[i] }} m/h
                      <template
                        :class="windSpeed[i] < 4 ? '' : 'alert'"
                        v-if="windSpeed[i] < 4 ? false : true"
                        >!</template
                      >
                    </strong>
                  </p>
                </v-flex>
              </div>
            </v-layout>
          </template>
        </v-card>
      </v-flex>

      <v-flex md12 sm12 lg12 xs12>
        <br />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import axiosApi from "../axios-api";
import axiosApi from "../../axios-api";

import moment from "moment-timezone";

import { mapMutations } from "vuex";

export default {
  components: {},
  data() {
    return {
      daily2: null,
      dialog: false,
      fill: "#ffffff",
      geojson: [],
      polygonHover: null,
      humidity: null,
      switch1: true,
      showPest: false,
      showClimate: false,
      showSector: true,
      showAnalysis: false,
      stroke: "#555555",
      hoverStroke: "#8BC34A",
      historical: null,
      strokeWidth: 2,
      fillOpacity: 0.9,
      fillOpacity2: 0.9,
      currentId: null,
      currentName: null,
      nave: "",
      rancho: "",
      historicHumidity: null,
      map: null,
      hover: false,
      geojsonMap: this.geojson,
      geojsonMap2: this.geojson2,
      options: {
        fill: "#ffffff",
      },
      url:
        "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoiam9zZXJhODkiLCJhIjoiY2p5Z2MwdDJ3MDFucDNubzR5bnhpd21oNyJ9.pki0YUIePeuqGEZjDsJAJw",
      center: [19.41146, -99.171841],
      // center: [],
      headers: [
        {
          text: "Hora",
          align: "start",
          value: "dt",
          sortable: true,
        },
        {
          text: "Descripcion",
          align: "start",
          value: "weather",
          sortable: true,
        },
        {
          text: "Temperatura [°C]",
          align: "start",
          value: "temp",
          sortable: true,
        },
        {
          text: "Humedad [%]",
          align: "start",
          value: "humidity",
          forecastReadyWeekly: false,
          sortable: true,
        },
      ],

      forecastReadyDaily: false,
      forecastReadyWeekly: false,
      forecast: [],
      weatherArray: [],
      date: [],
      humidityArray: [],
      tmax: [],
      tmin: [],
      weatherIconArray: [],
      windSpeed: [],
      rain: [],

      showTable: false,
      forecastHora: [],
    };
  },
  computed: {
    count() {
      return this.$store.state.subProject;
    },
  },
  watch: {
    count() {
      this.new();
    },
  },
  created: async function() {
    this.new();

    for (let i = 0; i < 12; i++) {
      this.forecastHora[i] = {
        dt: "",
        weather: "",
        temp: "",
        humidity: "",
        clouds: "",
        wind_speed: "",
        icon: "",
      };
    }
    // this.getForecast();
    this.new();
  },
  mounted() {},
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    new: async function() {
      let id = this.$store.state.subProjectsArr.find(
        (x) => x.name === this.$store.state.subProject
      ).id;
      this.geojson = await axiosApi.get(
        `/agrounit-geofence/get-all-by-subproject/${id}`
      );
      this.geojson = this.geojson.data;
      this.center = this.geojson[0].location.coordinates[0];
      this.center = this.center[0];

      console.log(
        "Test",
        this.geojson[0].location.coordinates[0][0],
        this.center
      );

      this.getForecast();
    },
    getForecast: async function() {
      let coordinates = [...this.geojson[0].location.coordinates[0][0]];
      let lat = coordinates[0];
      let long = coordinates[1];

      this.forecast = await axiosApi
        .get(
          `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${long}&units=imperial&lang=en&appid=ab5d66088e31a1c47b20b04fbf191a92`
        )
        .then((res) => {
          moment.locale("en");

          for (let i = 0; i < 7; i++) {
            this.date[i] = moment()
              .add(i, "days")
              .format("MMM Do");
            this.humidityArray[i] = res.data.daily[i].humidity;
            this.tmax[i] = res.data.daily[i].temp.max;
            this.tmin[i] = res.data.daily[i].temp.min;
            this.windSpeed[i] = res.data.daily[i].wind_speed;
            this.rain[i] = res.data.daily[i].rain;
            this.weatherIconArray[i] =
              "http://openweathermap.org/img/wn/" +
              res.data.daily[i].weather["0"].icon +
              "@2x.png";
            this.weatherArray[i] = res.data.daily[i].weather["0"].description;
          }

          for (let i = 0; i < 12; i++) {
            this.forecastHora[i].dt = moment()
              .add(i, "hours")
              .format("Do -  HH:mm");
            this.forecastHora[i].weather =
              res.data.hourly[i].weather[0].description;
            this.forecastHora[i].temp = res.data.hourly[i].temp;
            this.forecastHora[i].humidity = res.data.hourly[i].humidity;
            this.forecastHora[i].clouds = res.data.hourly[i].clouds;
            this.forecastHora[i].wind_speed = res.data.hourly[i].wind_speed;
            this.forecastHora[
              i
            ].icon = `http://openweathermap.org/img/wn/${res.data.hourly[i].weather[0].icon}@2x.png`;
          }
        });
      this.showTable = true;
    },
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    reset() {
      this.onClickBtn();
    },
    hoverHandler: function(polygon) {
      this.polygonHover = polygon;
      this.hover = true;
      this.currentId = polygon.id;
      this.currentName = polygon.name;
      if (polygon.rancho) {
        this.rancho = polygon.rancho;
      } else {
        this.rancho = "";
      }
    },
    swipeLeft() {
      let content = document.querySelector("#content");
      this.scrollTo(content, -250, 700);
    },
    swipeRight() {
      let content = document.querySelector("#content");
      this.scrollTo(content, 250, 700);
    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      // Condition to check if scrolling is required
      if (
        !(
          (scrollPos === 0 || scrollPixels > 0) &&
          (element.clientWidth + scrollPos === element.scrollWidth ||
            scrollPixels < 0)
        )
      ) {
        // Get the start timestamp
        const startTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();

        // eslint-disable-next-line no-inner-declarations
        function scroll(timestamp) {
          //Calculate the timeelapsed
          const timeElapsed = timestamp - startTime;
          //Calculate progress
          const progress = Math.min(timeElapsed / duration, 1);
          //Set the scrolleft
          element.scrollLeft = scrollPos + scrollPixels * progress;
          //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
          if (timeElapsed < duration) {
            //Request for animation
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        //Call requestAnimationFrame on scroll function first time
        window.requestAnimationFrame(scroll);
      }
    },
  },
};
</script>

<style lang="scss" scopped>
.icon {
  margin-right: 10px;
  margin-left: 10px;
}

.infoBox {
  border-radius: 5px;
  border: 1px solid #aaa9a9;
  background-color: #ffffff;
  color: rgb(44, 43, 43);
  margin-left: 70%;
  margin-top: 10px;
  opacity: 0.85;
  position: absolute !important;
  width: 200px;
}

.title {
  font-size: 40px !important;
}

.tableTitle {
  font-size: 0.5 rem !important;
  padding: 5px;
}

.layer-legend {
  border-radius: 5px;
  padding: 10px 20px 20px 20px;
  top: 70% !important;
  margin-left: 20px;
  position: absolute !important;
  z-index: 55555 !important;
  background-color: rgba(255, 255, 255, 0.8);
}

.layer-leyend .v-label {
  font-style: bold;
}

.title {
  font-size: 3rem !important;
}

.v-card {
  margin-top: 0px !important;
}

.vue2leaflet-map {
  border-radius: 8px !important;
  z-index: 0 !important;
}

.radio {
  margin-bottom: -40px;
  color: white !important;
}

.box {
  margin-left: 5% !important;
}

.weather-forecast {
  display: inline;
}

.forecast-box {
  margin-left: 1% !important;
  width: 98% !important;
}

p {
  font-size: 0.7rem !important;
  margin-top: -15px !important;
}

.daily {
  margin-bottom: -5px !important;
}

.day {
  height: 80% !important;
  margin-top: -20px;
}

.weatherIcon-daily {
  margin-top: -15px;
  margin-bottom: -5px;
  max-height: 60px !important;
}

.weatherIcon {
  max-height: 80px !important;
}

.map {
  height: 290px !important;
  margin-left: 1%;
  width: 98%;
}

.alert {
  color: red;
}

.rainy {
  color: #1e88e5;
}

.today {
  color: #558b2f;
  font-weight: bold !important;
}

.scrolling-wrapper {
  padding-left: 15px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  .card {
    display: inline-block;
    padding: 10px 15px 15px 15px !important;
    border-right: 1px solid lightgray;
  }
}

.nav {
  margin-top: 30px;
  height: 200px !important;
  z-index: 1 !important;
  padding-left: 10px !important;
  height: 50px !important;
  opacity: 0.35;
  border-radius: 35% !important;
}

.nav:hover {
  opacity: 0.9 !important;
}

@media only screen and (max-width: 600px) {
  .forecast-box {
    margin-top: 10% !important;
    margin-left: 4% !important;
    width: 93% !important;
  }

  .box {
    margin-top: 10% !important;
    margin-left: 4% !important;
    padding-left: 5% !important;
    width: 90% !important;
  }
}
</style>
